import {
  Dashboard,
  Widget,
} from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function sortByEmitter(dataPoints: any): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return dataPoints.sort((a: any, b: any) => a.emitter.localeCompare(b.emitter))
}

// Raw shape of a section in dashboard.configuration.sections: control dashboards
// emit {key, display, filter_values?}, legacy ones emit a plain string.
type RawSectionConfig =
  | string
  | { key: string; display: string; filter_values?: string[] }

export function getSections(dashboard: Dashboard): Section[] {
  const config = JSON.parse(dashboard.getConfiguration())
  const sections = (config['sections'] ?? []) as RawSectionConfig[]
  const sectionWidget = new Map<string, Section>()
  for (const section of sections) {
    if (typeof section === 'string') {
      sectionWidget.set(section, new Section(section, section, []))
    } else {
      sectionWidget.set(
        section.key,
        new Section(section.key, section.display, section.filter_values ?? []),
      )
    }
  }

  for (const widget of dashboard.getWidgetsList()) {
    const widgetName = widget.getName()
    const sepIdx = widgetName.lastIndexOf('/')
    if (sepIdx <= 0) continue
    const sectionKey = widgetName.substring(0, sepIdx)
    const type = widgetName.substring(sepIdx + 1)
    const s = sectionWidget.get(sectionKey)
    switch (type) {
      case 'recent':
        s?.setRecent(widget)
        break
      case 'historical':
        s?.setHistorical(widget)
        break
      case 'combined_historical':
        s?.setCombinedHistorical(widget)
        break
    }
  }
  return [...sectionWidget.values()]
}

export class Section {
  key: string
  name: string
  filterValues: string[]
  recent: Widget | undefined
  historical: Widget | undefined
  combinedHistorical: Widget | undefined

  constructor(key: string, name?: string, filterValues?: string[]) {
    this.key = key
    this.name = name ?? key
    this.filterValues = filterValues ?? []
  }

  getKey(): string {
    return this.key
  }

  getName(): string {
    return this.name
  }

  getFilterValues(): string[] {
    return this.filterValues
  }

  setRecent(value: Widget): void {
    this.recent = value
  }

  setHistorical(value: Widget): void {
    this.historical = value
  }

  setCombinedHistorical(value: Widget): void {
    this.combinedHistorical = value
  }

  getNameForRecent(): string {
    return this.recent === undefined ? '' : this.recent?.getName()
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDataForRecent(): any {
    if (this.recent == undefined) {
      return []
    }
    const data = JSON.parse(this.recent.getData())
    return data
  }

  getTimeBucketForRecent(): string {
    if (this.recent == undefined) {
      return ''
    }
    const config = JSON.parse(this.recent.getConfiguration())
    return config['time_bucket']
  }

  getNameForHistorical(): string {
    return this.historical === undefined ? '' : this.historical?.getName()
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDataForHistorical(): any {
    if (this.historical == undefined) {
      return []
    }
    const data = JSON.parse(this.historical.getData())
    return data
  }

  getTimeBucketForHistorical(): string {
    if (this.historical == undefined) {
      return ''
    }
    const config = JSON.parse(this.historical.getConfiguration())
    return config['time_bucket']
  }

  getNameForCombinedHistorical(): string {
    return this.combinedHistorical === undefined
      ? ''
      : this.combinedHistorical?.getName()
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDataForCombinedHistorical(): any {
    if (this.combinedHistorical == undefined) {
      return []
    }
    const data = JSON.parse(this.combinedHistorical.getData())
    return data
  }

  getTimeBucketForCombinedHistorical(): string {
    if (this.combinedHistorical == undefined) {
      return ''
    }
    const config = JSON.parse(this.combinedHistorical.getConfiguration())
    return config['time_bucket']
  }
}
